import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { DeleteLined } from '@tag/tag-icons';

import { useDeleteUploadedFile } from '../../hooks/useDeleteUploadedFile';
import { BulkClUpdate } from '../../abstractions/BuldClUpdate.interface';
import { useGetUploadedFiles } from '../../hooks/useGetUploadedFiles';
import { useAddQueryToUrl } from '@/components/common/TagTabs/useAddQueryToUrl';
import { BULK_CL_UPDATE_FILES_PER_PAGE } from '@/config/common.config';
import styles from './delete-icon.module.scss';

export default function DeleteButton({ data }: ICellRendererParams<BulkClUpdate>) {
  const { deleteFile } = useDeleteUploadedFile();
  const { getUploadedFiles } = useGetUploadedFiles();
  const { getValue } = useAddQueryToUrl();
  const currentPage = parseInt(getValue('page') ?? '1', 10);

  const updateList = () => {
    getUploadedFiles(currentPage, BULK_CL_UPDATE_FILES_PER_PAGE);
  };

  const onDelete = () => {
    deleteFile(data?.Id!, updateList);
  };

  return (
    <button
      className={styles.wrapper}
      onClick={onDelete}
    >
      <DeleteLined />
    </button>
  );
}
